import { showToast } from 'stores/ToastStore';
import i18next from 'i18next';
import client from './rest/AdminClient';
export const getMarkup = () => {
    return _getMarkup().then((response) => {
        return response;
    }, (error) => {
        showToast(i18next.t('MARKUP_FETCH_FAILED'), error, 'error');
        throw error;
    });
};
const _getMarkup = () => {
    return client({
        method: 'GET',
        path: `/api/1/marketplace/configurations/markup`,
    });
};
export const updateMarkup = (id, updates) => {
    return _updateMarkup(id, updates).then((response) => {
        showToast(i18next.t('UPDATE_MARKETPLACE_CONFIG'), i18next.t('MARKUP_UPDATED'));
        return response;
    }, (error) => {
        showToast(i18next.t('MARKUP_UPDATION_FAILED'), error, 'error');
        throw error;
    });
};
const _updateMarkup = (payload) => {
    return client({
        method: 'PATCH',
        path: `/api/1/marketplace/configurations/markup`,
        entity: JSON.stringify(payload),
    });
};
